import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Attach token from localStorage as Bearer (fallback) for cross-origin
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bm_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const fileUrl = (storagePath) => {
  if (!storagePath) return null;
  const token = localStorage.getItem("bm_token") || "";
  return `${API}/files/${storagePath}?auth=${encodeURIComponent(token)}`;
};

export const pdfUrl = (quoteId, variant = "proposal", lang = "pt") => {
  const token = localStorage.getItem("bm_token") || "";
  return `${API}/quotes/${quoteId}/pdf?variant=${variant}&lang=${lang}&auth=${encodeURIComponent(token)}`;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo correu mal. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtEUR = (n) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("pt-PT", {
    style: "currency",
    currency: "EUR",
  }).format(v);
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return "";
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
};
